<template>
  <div class="hvh-categories-collapsible" :class="{ 'pb-0': !value }">
    <div class="title">
      <h2 class="hvh-h7" :class="{ 'mr-1': help }">{{ title }}</h2>
      <v-icon class="icon clickable" size="19" @click.stop="visualizationHelpActive = true" v-if="help">mdi-help-circle-outline</v-icon>
      <hvh-modal :value="true" :title="help.title" @input="visualizationHelpActive = false" v-if="visualizationHelpActive">
        <template v-slot>
          <p v-for="(spl, ind) in help.text.split('\n')" :key="ind">
            {{ spl }}
          </p>
        </template>
      </hvh-modal>
    </div>
    <a class="v-label theme--light mdi mdi-close mdi-18px" :class="{ 'mdi-rotate-45': value }" @click.prevent="$emit('input', !value)"></a>
  </div>
</template>

<script>
export default {
  props: ['title', 'value', 'help'],
  data() {
    return {
      visualizationHelpActive: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.title {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.icon {
  color: rgb(17, 105, 125);
}
.hvh-categories-collapsible {
  display: flex;
  justify-content: space-between;
  padding: 16px;
}
</style>

